"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _TagsGroup = _interopRequireDefault(require("../../../../TagsGroup/TagsGroup"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ".articleTags-container {\n  display: flex;\n  align-items: end;\n  gap: 8px; }\n  .articleTags-container .artycle-type {\n    padding-bottom: 5px; }\n  .articleTags-container .tags-group {\n    display: inline; }\n    .articleTags-container .tags-group > div {\n      cursor: pointer; }\n";
  const fileName = "ArticleTags_ArticleTags";
  const element = document.querySelector("style[data-sass-component='ArticleTags_ArticleTags']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const ArticleTags = _ref => {
  let {
    item
  } = _ref;
  const main_tag = item?.main_tag && item?.main_tag[0].name ? {
    label: item?.main_tag[0].name,
    type: 'tertiary'
  } : undefined;
  const article_type = item?.article_type[0]?.name;
  const themen_media_tags = item?.themen_media_tags?.map(el => {
    return {
      label: el.name,
      type: 'tertiary'
    };
  }) || [];
  const items = main_tag ? [main_tag, ...themen_media_tags] : [...themen_media_tags];
  const tagItems = items.filter((item, index, self) => index === self.findIndex(t => t.label === item.label));
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "articleTags-container sia-padding-02-bottom"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "artycle-type sia-text-01 sia-padding-01-bottom"
  }, article_type), /*#__PURE__*/_react.default.createElement(_TagsGroup.default, {
    items: tagItems
  }));
};
var _default = exports.default = ArticleTags;